import _ from 'lodash';
import { COUNTRIES } from 'ziphy-web-shared/basic/utils/countries';
const preparedPhoneList = () => {
    let result = [];
    _.forEach(COUNTRIES, (country) => {
        result.push({
            label: country.label,
            iso2: country.iso2,
            dialCode: country.phone.dialCode,
            mask: country.phone.mask || '',
            areaCodes: country.phone.areaCodes || [],
        });
    });
    return result;
};
const preparedPhoneMap = () => {
    let result = {};
    _.forEach(PHONE_COUNTRIES, (phoneConfig) => {
        if (result[phoneConfig.dialCode]) {
            result[phoneConfig.dialCode].push(phoneConfig);
        }
        else {
            result[phoneConfig.dialCode] = [phoneConfig];
        }
    });
    return result;
};
const PHONE_COUNTRIES = preparedPhoneList();
const PHONE_COUNTRIES_MAP = preparedPhoneMap();
export { PHONE_COUNTRIES, PHONE_COUNTRIES_MAP };
